'use client';

// Types
import { ContentNavigationProps } from '@/types/components/contentNavigation';

// Hooks
import { useContentNavigation } from '@/hooks/useContentNavigation';

// Components
import { Heading } from '@preventx/oxygen';

export const ContentNavigationStandard = ({
  contentTitles,
  navigationTitle,
}: ContentNavigationProps) => {
  const { hash, onNavigationUpdate } = useContentNavigation();

  return (
    <nav className="toc article__toc">
      <Heading component="h2" size="h3" addEyebrow>
        {navigationTitle}
      </Heading>

      <div className="toc__wrapper">
        <ul className="toc__list">
          {contentTitles.map(({ id, title }) => (
            <li
              className="toc__listitem"
              key={`content-navigation-standard-${id}`}
            >
              <a
                href="#"
                onClick={(event) => onNavigationUpdate(event, id)}
                aria-current={hash === `#${id}` ? true : undefined}
              >
                {title}
              </a>
            </li>
          ))}
        </ul>
      </div>
    </nav>
  );
};
